export type ContractEditDialogMode =
    | "pending"
    | "signed"
    | "completed"
    | "cancelled"


export interface ContractEditDialogStateSource {
    signedAt?: Date | string
    isCancelled?: boolean
    completedAt?: Date | string
}


export class ContractEditDialogState {

    static modeForEntry(
        entry: ContractEditDialogStateSource
    ): ContractEditDialogMode {
        if (entry.isCancelled) {
            return "cancelled"
        }
        if (entry.completedAt) {
            return "completed"
        }
        if (entry.signedAt) {
            return "signed"
        }
        return "pending"
    }


    static allowsSaving(mode: ContractEditDialogMode): boolean {
        return mode === "pending" || mode === "signed"
    }


    static allowsCancellation(mode: ContractEditDialogMode): boolean {
        return mode === "pending" || mode === "signed"
    }


    /** "Märgi leping lõpetatuks" (Teostatud) — only once signed, and only once. */
    static allowsCompletion(mode: ContractEditDialogMode): boolean {
        return mode === "signed"
    }

}
